import OpacityAnimationDiv from '../../atoms/others/opacityAnimation';
import React, { useEffect, useState } from 'react';

function OpacityAnimation({
  animate = true,
  delay = 300,
  display = true,
  duration = 400,
  children,
}: {
  animate?: boolean;
  delay?: number;
  display?: boolean;
  duration?: number;
  children: React.ReactNode[] | React.ReactNode;
}) {
  const [opacity, setOpacity] = useState(animate ? 0 : 1);

  useEffect(() => {
    const opacityTimeout = setTimeout(() => {
      display && setOpacity(1);
    }, delay);

    return () => {
      clearTimeout(opacityTimeout);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setOpacity(display ? 1 : 0);
    }, delay);
  }, [display]);

  return (
    <OpacityAnimationDiv
      animation={{ transition: `opacity ${duration}ms` }}
      opacity={opacity}
    >
      {children}
    </OpacityAnimationDiv>
  );
}

export default OpacityAnimation;
